// extracted by mini-css-extract-plugin
module.exports = {"click":"AllocationWeight_click_3hmu2","edit":"AllocationWeight_edit_e2qKq"};